import Schema from 'async-validator';
import {
  accountKeys,
  companyAccountKeys,
  individualMeterKeys,
  ownerKeys,
} from './settingStepFieldKeys';
import { importTypes } from './importTypes';
import {
  createDateRule,
  createEmailRule,
  createIntegerRule,
  createNumberRule,
  createPhoneRule,
  createTextRule,
  createTypeRule,
} from '../../lib/fieldRules';
import { meterTextPattern } from '../../../../constants/patterns';

const meterTextMaxLength = 64;

const createOwnersDescriptor = ({ addressTypeIds }) => ({
  [ownerKeys.addressType]: createTypeRule({
    ids: addressTypeIds,
    label: 'ID типа помещения',
    required: true,
  }),

  [ownerKeys.flat]: createTextRule({
    required: true,
    label: 'Номер помещения',
  }),

  [ownerKeys.phone]: createPhoneRule(true),

  [ownerKeys.email]: createEmailRule(),
});

const createAccountsDescriptor = ({ addressTypeIds, accountTypeIds }) => ({
  [accountKeys.addressType]: createTypeRule({
    ids: addressTypeIds,
    label: 'ID типа помещения',
    required: true,
  }),

  [accountKeys.flat]: createTextRule({
    required: true,
    label: 'Номер помещения',
  }),

  [accountKeys.account]: createTextRule({
    required: true,
    label: 'Номер лицевого счета',
  }),

  [accountKeys.accountType]: createTypeRule({
    ids: accountTypeIds,
    label: 'ID типа лицевого счета',
    required: true,
  }),
});

const createCompanyAccountsDescriptor = () => ({
  [companyAccountKeys.account]: createTextRule({
    required: true,
    label: 'Лицевой счет',
  }),

  [companyAccountKeys.address]: createTextRule({
    required: true,
    label: 'Адрес',
  }),

  [companyAccountKeys.balance]: createNumberRule({
    required: true,
    label: 'Баланс',
  }),
});

const createIndividualMetersDescriptor = ({
  addressTypeIds,
  serviceTypeIds,
  locationTypeIds,
  statusTypeIds,
}) => ({
  [individualMeterKeys.addressType]: createTypeRule({
    ids: addressTypeIds,
    label: 'ID типа помещения',
    required: true,
  }),

  [individualMeterKeys.flat]: createTextRule({
    required: true,
    label: 'Номер помещения',
  }),

  [individualMeterKeys.serviceType]: createTypeRule({
    ids: serviceTypeIds,
    label: 'ID услуги',
    required: true,
  }),

  [individualMeterKeys.serialNumber]: createTextRule({
    label: 'Серийный номер',
    required: true,
    maxLength: meterTextMaxLength,
    pattern: meterTextPattern,
  }),

  [individualMeterKeys.model]: createTextRule({
    label: 'Модель',
    maxLength: meterTextMaxLength,
    pattern: meterTextPattern,
  }),

  [individualMeterKeys.mark]: createTextRule({
    label: 'Марка',
    maxLength: meterTextMaxLength,
    pattern: meterTextPattern,
  }),

  [individualMeterKeys.sealNumber]: createTextRule({
    label: 'Номер пломбы',
    maxLength: meterTextMaxLength,
    pattern: meterTextPattern,
  }),

  [individualMeterKeys.location]: createTypeRule({
    ids: locationTypeIds,
    label: 'ID места установки',
  }),

  [individualMeterKeys.readDateTime]: createDateRule({
    label: 'Дата показаний',
  }),

  [individualMeterKeys.reading1]: createNumberRule({
    label: 'Показания Т1',
  }),

  [individualMeterKeys.reading2]: createNumberRule({
    label: 'Показания Т2',
  }),

  [individualMeterKeys.reading3]: createNumberRule({
    label: 'Показания Т3',
  }),

  [individualMeterKeys.installationDateTime]: createDateRule({
    label: 'Дата установки',
  }),

  [individualMeterKeys.commissioningDateTime]: createDateRule({
    label: 'Дата ввода в эксплуатацию',
  }),

  [individualMeterKeys.verificationDateTime]: createDateRule({
    label: 'Дата поверки',
  }),

  [individualMeterKeys.verificationInterval]: createIntegerRule({
    label: 'Интервал поверки',
  }),

  [individualMeterKeys.status]: createTypeRule({
    ids: statusTypeIds,
    label: 'Статус счетчика',
  }),
});

export const validators = {
  [importTypes.owners]: (params) => {
    const descriptor = createOwnersDescriptor(params);
    return new Schema(descriptor);
  },

  [importTypes.personalAccounts]: (params) => {
    const descriptor = createAccountsDescriptor(params);
    return new Schema(descriptor);
  },

  [importTypes.personalAccountsByCompanies]: () =>
    new Schema(createCompanyAccountsDescriptor()),

  [importTypes.individualMeters]: ({
    addressTypeIds,
    meterTypeIds,
    meterLocationTypeIds,
    meterStatusTypeIds,
  }) => {
    const descriptor = createIndividualMetersDescriptor({
      addressTypeIds,
      serviceTypeIds: meterTypeIds,
      locationTypeIds: meterLocationTypeIds,
      statusTypeIds: meterStatusTypeIds,
    });
    return new Schema(descriptor);
  },
};
